import $ from 'jquery';

const $window = $(window);
const $bodyHtml = $('body,html');
const $html = $('html');
const $body = $('body');
const breakPoint1 = 750;

/* ======================================
body fix
====================================== */
let scrollPosi;

function bodyFix() {
  scrollPosi = $(window).scrollTop();
  $body.css({
    position: 'fixed',
    width: '100%',
    'z-index': '1',
    top: -scrollPosi,
  });
}

function bodyFixReset() {
  $body.css({
    position: 'relative',
    width: 'auto',
    top: '0',
  });
  $bodyHtml.scrollTop(scrollPosi);
}

/* ======================================
SP menu
====================================== */
$(function () {
  $('.js-open').on('click', function () {
    $(this).addClass("is-open");
    $('.js-nav').toggleClass('is-open');
    if ($(this).hasClass('is-open')) {
      bodyFix();
    } else {
      bodyFixReset();
    }
  });

  $('.js-close').on('click', function () {
    $('.js-open').removeClass("is-open");
    $('.js-nav').toggleClass('is-open');
    if ($(this).hasClass('is-open')) {
      bodyFix();
    } else {
      bodyFixReset();
    }
  });
});

//===================================================
// format
//===================================================
$(window).on('resize load', function () {
  if ($(window).width() > breakPoint1) {
    $body.removeAttr('style');
    $('.js-menu').removeClass('is-open');
    $('.js-nav').removeClass('is-open');
  } else {
  }
});
